import { useCallback, useMemo } from 'react';

import type { DeclarativeMenuConfig } from 'src/components/declarative-menu';
import { docsRoute } from 'src/config';
import { ClientTransforms } from 'src/editor/transforms';
import { emailWithSubject, openLink } from 'src/helpers';
import { useEditor } from 'src/layout-engine/hooks';

export function useHelpMenu() {
  const editor = useEditor();

  const alineDocs = useCallback(() => {
    openLink(docsRoute, { title: 'alineDocs' });
    ClientTransforms.focus(editor);
  }, [editor]);

  const reportProblem = useCallback(() => {
    emailWithSubject({ subject: 'Problem With Aline' });
    ClientTransforms.focus(editor);
  }, [editor]);

  return useMemo(
    (): DeclarativeMenuConfig => [
      { label: 'Report a problem', onClick: reportProblem },
      { label: 'Aline product docs', onClick: alineDocs },
    ],
    [alineDocs, reportProblem]
  );
}
